import { QueryTuple, useLazyQuery } from '@apollo/client';
import { CrewMemberList } from '@bechtel/types';
import { LOAD_ASSOCIATED_CREWMEMBER } from '@bechtel/client-gql';

export function useAssociatedCrewMember(
  fetchFromNetwork?: boolean
): QueryTuple<{ crewMembers: CrewMemberList }, Record<string, any>> {
  const response = useLazyQuery<{ crewMembers: CrewMemberList }>(
    LOAD_ASSOCIATED_CREWMEMBER,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
